export default {
    // modules/header
    navbar: '100',

    // modules/date-range-picker
    dateRangePickerDropdown: '90',

    // modules/tags
    addTagDropdownOverlay: '80',

    // modules/ui/modules/messages
    messages: '50',
};
